export default {
  "content": "<path d=\"M7.926 1a6.744 6.744 0 013.622 1.049c2.815 1.784 3.022 5.47.78 8.164a35.157 35.157 0 01-4.212 4.26.297.297 0 01-.38 0 35.14 35.14 0 01-4.211-4.26c-2.243-2.694-2.036-6.38.78-8.164A6.744 6.744 0 017.925 1z\" fill=\"#D6C2FF\" stroke=\"#BA9CFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};